import React from 'react'
import UserPainel from '../Integration/UserPainel'
import Header from '../Integration/Header'
function PageUser() {
  return (
    <div>
      <Header/>
        <UserPainel/>
        </div>
  )
}

export default PageUser